import React from "react"
import styled from "styled-components"
import { FaInstagram, FaFacebook, FaWhatsapp } from "react-icons/fa"

export default function SocialMedia() {
  return (
    <Wrapper>
      <a
        className="instagram"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.instagram.com/rustic_homestead_chile/"
      >
        <FaInstagram />
      </a>
      <a
        className="facebook"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.facebook.com/rustic_homestead_chile-101549548604440"
      >
        <FaFacebook />
      </a>
      <a
        className="whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        href="https://bit.ly/2ODjVI4"
      >
        <FaWhatsapp />
      </a>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  a {
    margin-right: 10px;
    svg {
      font-size: 1.675rem;
      opacity: 0.75;
      transform-origin: 50% 50%;
      transition: opacity 0.3s ease, transform 0.3s ease;
      &:hover {
        opacity: 1;
        transform: scale(1.2) rotate(360deg);
      }
    }
  }
  .instagram {
    color: #c12fa2;
  }

  .facebook {
    color: rgb(24, 119, 242);
  }

  .whatsapp {
    color: rgb(0, 154, 51);
  }
`
